import classnames from 'classnames';
import React from 'react';

import Colors from '../colors';
import { FlagIcon, WarningIcon } from '../icons/icons';
import { Icon } from '../icon';

import styles from './ListItemBanner.css';

type ListBannerType = 'unpublished' | 'integration';
type ColorMap = { [key in ListBannerType]: Colors };

interface Props {
  /** Message to be shown on the banner */
  children?: React.ReactNode;
  /** Provides visual elements that determine if the banner is an unpublished, or a integration error message */
  type?: ListBannerType;
  /** Adds additional classes to the component. */
  className?: string;
}

const colorMap: ColorMap = {
  unpublished: Colors.UnbounceBlue,
  integration: Colors.Orange
};

export const ListItemBanner = (props: Props) => {
  const { type = 'unpublished', children, className } = props;
  const bannerClasses = classnames(styles.banner, className, {
    [styles[type]]: true
  });

  const BannerIcon = () => {
    switch (type) {
      case 'unpublished':
        return <FlagIcon data-testid="unpublish-icon" />;
      case 'integration':
        return <WarningIcon data-testid="integration-error-icon" />;
    }
  };

  return (
    <div className={bannerClasses} data-testid="list-banner">
      <Icon color={colorMap[type]} className={styles.icon}>
        <BannerIcon />
      </Icon>
      <span className={styles.bannerText} data-testid="list-banner-text">
        {children}
      </span>
    </div>
  );
};

export default ListItemBanner;
